// Standard fbq events https://developers.facebook.com/docs/meta-pixel/reference#standard-events
export const META_PIXEL_EVENT_DATA = {
  Purchase: { currency: "", value: 0 },
};
